import { render } from "./ProjectCardSmall.vue?vue&type=template&id=406087bb&scoped=true"
import script from "./ProjectCardSmall.vue?vue&type=script&lang=js"
export * from "./ProjectCardSmall.vue?vue&type=script&lang=js"

import "./ProjectCardSmall.vue?vue&type=style&index=0&id=406087bb&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-406087bb"]])

export default __exports__